import { tFinanceRecord } from "../App";
import './CustomerFeedbackPopup.css';

interface FinanceReportPopupProps {
  financeHistory: tFinanceRecord[];
  closeFinanceReportCallback: () => void;
}

export default function FinanceReportPopup(props: FinanceReportPopupProps) {
  return (
    <div className="popup-overlay">
      <div className={`customer-feedback-popup-modal`}>
        <h3>🏦 Finance Report</h3>
        <table className="feedback-table">
          <thead>
            <tr>
              <th>Sprint</th>
              <th>Revenue</th>
              <th>Wages</th>
              <th>Balance</th>
              <th>Version</th>
            </tr>
          </thead>
          <tbody>
            {props.financeHistory.map((record, index) => {
              return (
                <tr key={index}>
                  <td>{record.sprint}</td>
                  <td style={{ textAlign: 'right' }}>£{record.income}</td>
                  <td style={{ textAlign: 'right' }}>£{record.wages}</td>
                  <td style={{ textAlign: 'right', color: record.balance >= 0 ? 'black' : 'red' }}>
                    £{record.balance}
                  </td>
                  <td style={{ textAlign: 'center' }}>{record.releaseVersion.toFixed(1)}</td>
                </tr>
              )
            })}
          </tbody>
        </table>
        <button className="close-button" onClick={props.closeFinanceReportCallback}>Close</button>
      </div>
    </div>
  );
}
